module.exports = __webpack_public_path__ + "img/service-sp-screen-editor.d17edb77.png";